var map = {
	"./anonymous.svg": [
		20068,
		20068
	],
	"./bronze.svg": [
		26137,
		26137
	],
	"./casanova.svg": [
		49163,
		49163
	],
	"./crush.svg": [
		94750,
		94750
	],
	"./diamond.svg": [
		2507,
		2507
	],
	"./eros.gif": [
		19450,
		19450
	],
	"./gold.svg": [
		1387,
		1387
	],
	"./lancelot.svg": [
		75583,
		75583
	],
	"./lover.svg": [
		84613,
		84613
	],
	"./platinum.svg": [
		7301,
		7301
	],
	"./romeo.svg": [
		29933,
		29933
	],
	"./secret.svg": [
		31329,
		31329
	],
	"./signature.svg": [
		89077,
		89077
	],
	"./silver.svg": [
		81550,
		81550
	],
	"./sweetheart.svg": [
		97685,
		97685
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 95570;
module.exports = webpackAsyncContext;